import Cookies from 'js-cookie';
import DirectoryService from '../../directory/DirectoryService';

// Cookie key used to cache the calculated Monthly Revenue widget data so we
// don't have to recompute it (which requires fetching all payments + all
// users) every time the WOD dashboard is opened.
const MONTHLY_REVENUE_COOKIE_PREFIX = 'monthlyRevenue_';

// LocalStorage key used to cache the payments retrieved for the logged in
// user's account, so we don't have to hit the backend every time
// retrievePaymentsByAccount() is called. This is populated the first time
// it's requested after login, and cleared on logout (LoginService clears
// localStorage on logout/login), so it's effectively recreated once per
// login session.
const PAYMENTS_STORAGE_PREFIX = 'payments_';

// Normalizes the [year, month, day, hour, minute, second] array format used
// by the backend for dates into a real JS Date object.
const toDateFromArray = dateArray => {
  if (!dateArray || !Array.isArray(dateArray)) return null;
  const [year, month, day, hour = 0, minute = 0, second = 0] = dateArray;
  return new Date(year, month - 1, day, hour, minute, second);
};

const PaymentService = {

  async saveWODProduct(formData) {
    try {
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      let url = '/api/wod/product';
      let method = 'POST';
      if (formData.identifier !== undefined) {
        url = '/api/wod/product/' + formData.identifier;
        method = 'PUT';
      }
      const updateData = {
        ...formData,
        accountIdentifier: accountIdentifier,
        billingCyrcle: formData.billingCyrcle.value
      }
      console.log('UpdateData', updateData);
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      });
      if (response.ok) {
        const newPayment = await response.json();
        console.log('Payment has been updated:', newPayment);
      }
    } catch (error) {
      console.log('Error saving Payment', error);
    }
  },
  async saveWODAthlete(formData) {
    //TODO
    try {
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      let url = '/api/wod/product/account/{accountIdentifier}/customers/stripe';
      let method = 'POST';
      if (formData.identifier !== undefined) {
        url = '/api/wod/product/account/' + accountIdentifier + '/customers/' + formData.identifier + '/stripe';
        method = 'PUT';
      }
      const updateData = {
        ...formData,
        accountIdentifier: accountIdentifier
      };
      console.log('UpdateData', updateData);
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      });
      if (response.ok) {
        const savedAthlete = await response.json();
        console.log('Athlete has been saved:', savedAthlete);
        return savedAthlete;
      } else {
        throw new Error('Failed to save athlete');
      }
    } catch (error) {
      console.log('Error saving Athlete', error);
      throw error;
    }
  },
  async importAthleteFromStripe(customer) {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      const url = '/api/wod/product/account/' + accountIdentifier + '/customers/stripe';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...customer,
          accountIdentifier: accountIdentifier
        })
      });
      if (response.ok) {
        const importedAthlete = await response.json();
        console.log('Athlete imported successfully:', importedAthlete);
        return importedAthlete;
      } else {
        throw new Error('Failed to import athlete');
      }
    } catch (error) {
      console.log('Error importing athlete from Stripe', error);
      throw error;
    }
  },
   async saveAthlete(formData) {
    try {
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      let url = '/api/profile';
      let method = 'POST';
      if (formData.identifier !== undefined) {
        url = '/api/profile';
        method = 'PUT';
      }

      const wodProduct = await this.retrieveWODProduct(formData.membershipPlan.value);
      const updateData = {
        ...formData,
        accountIdentifier: accountIdentifier,
        membershipPlan: wodProduct,
        groups: [],
        roles: ['WOD'],
      }
      console.log(updateData);
      console.log('UpdateData', updateData);
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      });
      if (response.ok) {
        const newPayment = await response.json();
        console.log('Payment has been updated:', newPayment);
      }
    } catch (error) {
      console.log('Error saving Payment', error);
    }
  },
  async purchaseMembership(productIdentifier) {
    try {
      const profile = JSON.parse(localStorage.getItem('profile'));
      const url = '/api/wod/payment/purchase';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ profileIdentifier: profile.identifier, accountIdentifier: profile.accountIdentifier, productIdentifier })
      });
      if (response.ok) {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.log('Error purchasing membership', error);
    }
  },
  async connectExistentStripeAccount(accountId){
    // TODO Deberia validar si existe esta cuenta? Y esto hacerlo directamente en el backend?
    // Deberia ir mostrando el proceso desde que se encuentra le cuenta 
    // hasta que crea los productos (y los actualiza?)
    const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
    const url = '/api/wod/payment/account/' + accountIdentifier + '/stripe/' + accountId + '/restore';

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log(response);
      if (response.ok) {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.log('Error connecting to Stripe', error);
    }
  },
  async connectStripe(){
    const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
    const url = '/api/wod/payment/account/' + accountIdentifier + '/stripe/connect';

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      console.log(response);
      if (response.ok) {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.log('Error connecting to Stripe', error);
    }
  },
  async retrieveAllPaymentByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch('/api/<your_controller>' + accountIdentifier);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Payment', error);
      throw error;
    }
  },
  async retrieveGymDetails() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch('/api/wod/product/account/' + accountIdentifier + '/details');
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Payment', error);
      throw error;
    }
  },
  async retrieveAllProductsByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch('/api/wod/product/account/' + accountIdentifier);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Payment', error);
      throw error;
    }
  },
  async retrieveAllProductsFromStripe() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch('/api/wod/product/account/' + accountIdentifier + '/stripe');
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Payment', error);
      throw error;
    }
  },
   async retrieveAllCustomersFromStripe() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch('/api/wod/product/account/' + accountIdentifier + '/customers/stripe');
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Payment', error);
      throw error;
    }
  }, 
  async retrieveAthlete(identifier){
    try {
      const response = await fetch('/api/wod/settings/athelete/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Payment', error);
      throw error;
    }
  },
  async retrieveWODProduct(identifier){
    try {
      console.log('Retrieving WOD Product with identifier:', identifier);
      const response = await fetch('/api/wod/product/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Payment', error);
      throw error;
    }
  },
  async retrievePayment(identifier) {
    try {
      const response = await fetch('/api/<your_controller>/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Payment', error);
      throw error;
    }
  },
    async deleteWODProduct(identifier) {
    try {
      let url = '/api/wod/product/' + identifier;
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const newPayment = await response.json();
        console.log('Product has been deleted:', newPayment);
      }
    } catch (error) {
      console.log('Error deleting Product', error);
    }
  },
  async deletePayment(identifier) {
    try {
      let url = '/api/<your_controller>';
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newPayment = await response.json();
        console.log('Payment has been deleted:', newPayment);
      }
    } catch (error) {
      console.log('Error deleting Payment', error);
    }
  },
  async importProductFromStripe(product) {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      const url = '/api/wod/product/import';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...product,
          accountIdentifier: accountIdentifier
        })
      });
      if (response.ok) {
        const importedProduct = await response.json();
        console.log('Product imported successfully:', importedProduct);
        return importedProduct;
      } else {
        throw new Error('Failed to import product');
      }
    } catch (error) {
      console.log('Error importing product from Stripe', error);
      throw error;
    }
  },
  async unlinkProductFromProfile(profileIdentifier) {
    try {
      const url = '/api/wod/payment/manual/' + profileIdentifier + '/unlink';
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const text = await response.text();
        const data = text ? JSON.parse(text) : null;
        console.log('Product has been unlinked from profile:', data);
        return data;
      } else {
        throw new Error('Failed to unlink product from profile');
      }
    } catch (error) {
      console.log('Error unlinking product from profile', error);
      throw error;
    }
  },
  async linkProductToProfile(profileIdentifier, productIdentifier) {
    try {
      const url = '/api/wod/payment/manual/' + profileIdentifier + '/' + productIdentifier;
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const data = await response.json();
        console.log('Product has been linked to profile:', data);
        return data;
      } else {
        throw new Error('Failed to link product to profile');
      }
    } catch (error) {
      console.log('Error linking product to profile', error);
      throw error;
    }
  },

  async retrievePaymentsByAccount(forceRefresh = false) {
    const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
    const storageKey = PAYMENTS_STORAGE_PREFIX + accountIdentifier;

    if (!forceRefresh) {
      const cached = localStorage.getItem(storageKey);
      if (cached) {
        try {
          return JSON.parse(cached);
        } catch (error) {
          console.log(
            'Error parsing cached payments, fetching from backend',
            error
          );
        }
      }
    }

    try {
      const url = `/api/wod/product/account/${accountIdentifier}/payments`;
      const response = await fetch(url);
      if (response.ok) {
        const payments = await response.json();
        localStorage.setItem(storageKey, JSON.stringify(payments));
        return payments;
      } else {
        throw new Error('Failed to retrieve payments');
      }
    } catch (error) {
      console.error('Error fetching payments', error);
      throw error;
    }
  },
  /**
   * Builds (and caches for 1 day in a cookie) the data used by the
   * "Monthly revenue" widget on the WOD Admin dashboard:
   *
   *  - current: total of succeeded payments for the current calendar month
   *    (using the same payments returned by retrievePaymentsByAccount()).
   *  - change / isPositive: current month total compared against last
   *    month's total (e.g. August vs July).
   *  - predicted: current month total plus the expected recurring revenue
   *    from active athletes (DirectoryService.retrieveUsersByAccount()) who
   *    haven't renewed yet this month - assuming monthly billing, using
   *    membershipPlan.price, status === 'succeeded' and their last
   *    paymentDate (e.g. [2026, 8, 3, 10, 19, 53]).
   *  - trend: cumulative revenue collected so far this month, split into 8
   *    buckets (roughly two per week) to draw the sparkline.
   */
  async retrieveMonthlyRevenueData(forceRefresh = false) {
    const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
    const cookieKey = MONTHLY_REVENUE_COOKIE_PREFIX + accountIdentifier;

    if (!forceRefresh) {
      const cached = Cookies.get(cookieKey);
      if (cached) {
        try {
          return JSON.parse(cached);
        } catch (error) {
          console.log(
            'Error parsing cached monthly revenue, recalculating',
            error
          );
        }
      }
    }

    try {
      const [payments, users] = await Promise.all([
        this.retrievePaymentsByAccount(),
        DirectoryService.retrieveUsersByAccount()
      ]);

      const now = new Date();
      const currentMonth = now.getMonth();
      const currentYear = now.getFullYear();
      const previousMonthDate = new Date(currentYear, currentMonth - 1, 1);
      const previousMonth = previousMonthDate.getMonth();
      const previousMonthYear = previousMonthDate.getFullYear();

      const isInMonth = (date, month, year) =>
        !!date && date.getMonth() === month && date.getFullYear() === year;

      const succeededPayments = (payments || []).filter(
        p => p.status === 'succeeded' && p.paymentDate
      );

      // --- Current month total (e.g. August) ---
      const currentMonthPayments = succeededPayments.filter(p =>
        isInMonth(toDateFromArray(p.paymentDate), currentMonth, currentYear)
      );
      const current = currentMonthPayments.reduce(
        (sum, p) => sum + (Number(p.amount) || 0),
        0
      );

      // --- Previous month total (e.g. July), used for the "change" value ---
      const previousMonthPayments = succeededPayments.filter(p =>
        isInMonth(
          toDateFromArray(p.paymentDate),
          previousMonth,
          previousMonthYear
        )
      );
      const previousTotal = previousMonthPayments.reduce(
        (sum, p) => sum + (Number(p.amount) || 0),
        0
      );

      const isPositive = current >= previousTotal;
      const change = Math.abs(current - previousTotal);

      // --- Predicted revenue for the current month ---
      // Money already collected this month, plus the recurring membership
      // price for every active athlete who hasn't renewed yet this month.
      const expectedAdditional = (users || [])
        .filter(
          u =>
            u.status === 'succeeded' &&
            u.membershipPlan?.price &&
            u.paymentDate
        )
        .reduce((sum, u) => {
          const lastPaymentDate = toDateFromArray(u.paymentDate);
          const paidThisMonth = isInMonth(
            lastPaymentDate,
            currentMonth,
            currentYear
          );
          return paidThisMonth ? sum : sum + Number(u.membershipPlan.price);
        }, 0);
      const predicted = current + expectedAdditional;

      // --- Trend (sparkline): cumulative revenue collected so far this
      // month, split into 8 buckets (roughly two per week) ---
      const today = now.getDate();
      const bucketsCount = 8;
      const bucketSize = Math.max(1, Math.ceil(today / bucketsCount));
      const trend = [];
      for (let i = 1; i <= bucketsCount; i++) {
        const dayLimit = Math.min(today, i * bucketSize);
        const cumulative = currentMonthPayments
          .filter(p => toDateFromArray(p.paymentDate).getDate() <= dayLimit)
          .reduce((sum, p) => sum + (Number(p.amount) || 0), 0);
        trend.push(Number(cumulative.toFixed(2)));
      }
      // Make sure the sparkline always ends exactly on the current total.
      trend[trend.length - 1] = Number(current.toFixed(2));

      const monthlyRevenue = {
        current: Number(current.toFixed(2)),
        change: Number(change.toFixed(2)),
        isPositive,
        predicted: Number(predicted.toFixed(2)),
        trend
      };

      Cookies.set(cookieKey, JSON.stringify(monthlyRevenue), {
        expires: 1,
        sameSite: 'lax'
      });

      return monthlyRevenue;
    } catch (error) {
      console.error('Error calculating monthly revenue', error);
      throw error;
    }
  }
};
export default PaymentService;
